import { User } from '../models/user';

export class SetUserInfo {
    public static readonly type = '[User] SetUserInfo';

    constructor(public payload: User) {}
}
